/* Mantelly mix & match (29/09/2026): cor/design/estilo por unidade nos pacotes da escada.
   Desenho: loja/fase2/mix-match/DESENHO.md. Painel SSR em snippets/mt-mix-picker.liquid.
   - Fonte da verdade da variante: input[name="id"] de #product-form-{section}. O tema dispara 'change' nele a cada
     troca (card do nível, pill, sticky de desktop), antes de buscar a seção: o painel responde na hora.
   - O painel fica FORA do <variant-selects> (o sticky de desktop troca o innerHTML dele).
   - Os inputs properties[Items] / properties[_SKUs] ficam sempre atualizados no DOM: o sticky chama
     productForm.handleSubmit() direto, sem evento 'submit'. Nível de 1 unidade = inputs sem name.
   - O tema injeta o valor da property cru no HTML (value="..."): tirar aspas e <>, & vira "and". */
(function () {
  if (!window.customElements || customElements.get('mt-mix-picker')) return;

  var KNOWN = ['color', 'colour', 'design', 'style', 'size', 'pattern', 'scent', 'flavor', 'model', 'theme'];

  function clean(s) {
    return String(s == null ? '' : s).replace(/["<>]/g, '').replace(/&/g, 'and').replace(/, /g, ' ').replace(/,/g, ' ').trim();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  // "Buy 2 Get 1 FREE" -> itens 3.. FREE; "Buy 1 Get 1 50% OFF" -> item 2 50% OFF (só se X+Y = unidades do nível)
  function chipFor(tier, n) {
    var m = /^\s*buy\s+(\d+)\s+get\s+(\d+)\s+(free|(\d+)\s*%\s*off)\s*$/i.exec(tier || '');
    if (!m) return null;
    var x = +m[1], y = +m[2];
    if (x < 1 || x + y !== n) return null;
    return { from: x, text: m[4] ? m[4] + '% OFF' : 'FREE' };
  }

  class MtMix extends HTMLElement {
    connectedCallback() {
      if (this._ok) return;
      var s = this.querySelector('script[type="application/json"]');
      if (!s) return;
      try { this.d = JSON.parse(s.textContent); } catch (e) { return; }
      this._ok = true;
      this.sid = this.dataset.section;
      this.t = this.d.t;
      this.O = this.d.o;
      this.V = this.d.v;
      this.byId = {};
      this.hasImg = false;
      for (var i = 0; i < this.V.length; i++) {
        this.byId[String(this.V[i].id)] = this.V[i];
        if (this.V[i].img) this.hasImg = true;
      }
      this.rowsEl = this.querySelector('.mt-mix__rows');
      this.titleEl = this.querySelector('.mt-mix__title');
      this.fixedEl = this.querySelector('.mt-mix__fixed');
      this.pItems = this.querySelector('.mt-mix__prop[data-key="Items"]');
      this.pSkus = this.querySelector('.mt-mix__prop[data-key="_SKUs"]');
      this.key = this.rowsEl.getAttribute('data-key') || '';
      this.mem = [];
      // O que está nas linhas do servidor vale (o cliente pode ter mexido antes de o JS subir).
      var cur = this.current();
      if (cur) {
        var rows = this.rowsEl.querySelectorAll('.mt-mix__row');
        for (var r = 0; r < rows.length; r++) this.mem[r] = this.readRow(rows[r], this.pickOf(cur));
      }
      var self = this;
      this._onRow = function (e) { self.onRow(e); };
      this.rowsEl.addEventListener('change', this._onRow);
      this._onDoc = function (e) {
        var tg = e.target;
        if (!tg || tg.name !== 'id' || !tg.form || tg.form.id !== 'product-form-' + self.sid) return;
        self.sync();
      };
      document.addEventListener('change', this._onDoc);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this._unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
          var dd = ev && ev.data;
          if (dd && String(dd.sectionId) === String(self.sid)) self.sync();
        });
      }
      this.sync();
    }

    disconnectedCallback() {
      if (!this._ok) return;
      this._ok = false;
      document.removeEventListener('change', this._onDoc);
      if (this.rowsEl) this.rowsEl.removeEventListener('change', this._onRow);
      if (typeof this._unsub === 'function') this._unsub();
    }

    // ---------- dados ----------
    current() {
      var f = document.getElementById('product-form-' + this.sid);
      var inp = f && f.querySelector('input[name="id"]');
      return (inp && this.byId[String(inp.value)]) || this.byId[String(this.dataset.cv)] || null;
    }
    pickOf(v) {
      var p = [];
      for (var j = 0; j < this.O.length; j++) p.push(v.o[this.O[j].i]);
      return p;
    }
    jOf(k) {
      for (var j = 0; j < this.O.length; j++) if (this.O[j].i === k) return j;
      return -1;
    }
    find(tier, p) {
      for (var i = 0; i < this.V.length; i++) {
        var v = this.V[i];
        if (v.o[this.t] !== tier) continue;
        var ok = true;
        for (var j = 0; j < this.O.length; j++) if (v.o[this.O[j].i] !== p[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    // Valor de uma opção no nível: 1 = alguma combinação disponível (se a da linha não estiver, fix() troca a outra
    // opção da linha), 0 = esgotado em todas, -1 = não existe no nível
    state(tier, j, val) {
      var st = -1;
      for (var i = 0; i < this.V.length; i++) {
        var v = this.V[i];
        if (v.o[this.t] !== tier || v.o[this.O[j].i] !== val) continue;
        if (v.a) return 1;
        st = 0;
      }
      return st;
    }
    // opções (índice da opção no produto) com 2+ valores disponíveis no nível
    active(tier) {
      var out = [];
      for (var j = 0; j < this.O.length; j++) {
        var seen = {}, c = 0;
        for (var i = 0; i < this.V.length; i++) {
          var v = this.V[i], val = v.o[this.O[j].i];
          if (v.o[this.t] === tier && v.a && !seen[val]) { seen[val] = 1; c++; }
        }
        if (c > 1) out.push(this.O[j].i);
      }
      return out;
    }
    locked(tier) {
      var p = null;
      for (var i = 0; i < this.V.length; i++) {
        if (this.V[i].o[this.t] !== tier) continue;
        if (p === null) p = this.V[i].p; else if (this.V[i].p !== p) return true;
      }
      return false;
    }
    // combinação indisponível no nível: muda outra opção da linha (nunca a que o cliente acabou de escolher)
    fix(tier, p, keep) {
      var v = this.find(tier, p);
      if (v && v.a) return p;
      for (var j = 0; j < this.O.length; j++) {
        if (j === keep) continue;
        for (var x = 0; x < this.O[j].v.length; x++) {
          var p2 = p.slice(); p2[j] = this.O[j].v[x];
          var w = this.find(tier, p2);
          if (w && w.a) return p2;
        }
      }
      for (var i = 0; i < this.V.length; i++) if (this.V[i].o[this.t] === tier && this.V[i].a) return this.pickOf(this.V[i]);
      return p;
    }
    oneUnit(p) {
      for (var i = 0; i < this.V.length; i++) {
        var v = this.V[i];
        if (v.u !== 1) continue;
        var ok = true;
        for (var j = 0; j < this.O.length; j++) if (v.o[this.O[j].i] !== p[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    readRow(row, base) {
      var p = base.slice();
      var sels = row.querySelectorAll('select[data-k]');
      for (var s = 0; s < sels.length; s++) {
        var j = this.jOf(+sels[s].getAttribute('data-k'));
        if (j > -1 && sels[s].value) p[j] = sels[s].value;
      }
      return p;
    }
    title(act) {
      var names = [], known = true;
      for (var a = 0; a < act.length; a++) {
        var nm = String(this.O[this.jOf(act[a])].n).toLowerCase().trim();
        if (KNOWN.indexOf(nm) < 0) known = false;
        names.push(nm);
      }
      if (names.length && names.length < 3 && known) return 'Pick a ' + names.join(' and ') + ' for each item';
      return 'Pick your options for each item';
    }

    // ---------- estado ----------
    sync() {
      var cur = this.current();
      if (!cur) { this.setOn(false); return; }
      var tier = cur.o[this.t], n = cur.u || 1;
      var act = this.active(tier);
      var on = n > 1 && act.length > 0 && !this.locked(tier);
      this.mem[0] = this.pickOf(cur);
      if (!on) { this.setOn(false); return; }
      for (var i = 1; i < n; i++) {
        this.mem[i] = this.fix(tier, (this.mem[i] || this.mem[0]).slice(), -1);
      }
      this.tier = tier; this.n = n; this.act = act;
      var key = tier + '|' + n + '|' + act.map(function (k) { return k + ','; }).join('');
      if (key !== this.key) { this.build(tier, n, act); this.key = key; this.rowsEl.setAttribute('data-key', key); }
      this.paint();
      this.setOn(true);
    }

    setOn(on) {
      this.hidden = !on;
      var vs = document.getElementById('variant-selects-' + this.sid);
      if (vs) vs.setAttribute('data-mt-mix', on ? 'on' : 'off');
      if (!on) {
        this.pItems.removeAttribute('name'); this.pItems.value = '';
        this.pSkus.removeAttribute('name'); this.pSkus.value = '';
        return;
      }
      this.write();
    }

    build(tier, n, act) {
      var cf = chipFor(tier, n), h = '';
      for (var i = 0; i < n; i++) {
        var p = this.mem[i], v = this.find(tier, p);
        h += '<div class="mt-mix__row" data-i="' + i + '" role="group" aria-label="Item ' + (i + 1) + '">';
        if (this.hasImg) {
          h += '<span class="mt-mix__thumb">' + (v && v.img ? '<img src="' + esc(v.img) + '" alt="" width="36" height="36" loading="lazy">' : '') + '</span>';
        }
        h += '<span class="mt-mix__label"><span class="mt-mix__n">Item ' + (i + 1) + '</span>' +
          (cf && i >= cf.from ? '<span class="mt-mix__chip">' + esc(cf.text) + '</span>' : '') + '</span><span class="mt-mix__sels">';
        for (var a = 0; a < act.length; a++) {
          var o = this.O[this.jOf(act[a])];
          h += '<span class="mt-mix__sel"><select data-k="' + o.i + '" aria-label="' + esc(o.n) + '" autocomplete="off">';
          for (var x = 0; x < o.v.length; x++) h += '<option value="' + esc(o.v[x]) + '">' + esc(o.v[x]) + '</option>';
          h += '</select></span>';
        }
        h += '</span></div>';
      }
      this.rowsEl.innerHTML = h;
      this.classList.toggle('mt-mix--two', act.length > 1);
      this.titleEl.textContent = this.title(act);
    }

    // valores, esgotados, miniaturas e a linha das opções fixas
    paint() {
      var tier = this.tier, rows = this.rowsEl.querySelectorAll('.mt-mix__row');
      for (var i = 0; i < rows.length && i < this.n; i++) {
        var p = this.mem[i], sels = rows[i].querySelectorAll('select[data-k]');
        for (var s = 0; s < sels.length; s++) {
          var sel = sels[s], j = this.jOf(+sel.getAttribute('data-k'));
          for (var x = 0; x < sel.options.length; x++) {
            var op = sel.options[x], st = this.state(tier, j, op.value);
            var txt = op.value + (st === 0 ? ' · Sold out' : st === -1 ? ' · Unavailable' : '');
            if (op.textContent !== txt) op.textContent = txt;
            op.disabled = st !== 1;
            op.hidden = st === -1;
          }
          if (sel.value !== p[j]) sel.value = p[j];
        }
        var v = this.find(tier, p), img = rows[i].querySelector('.mt-mix__thumb img');
        if (v && v.img) {
          if (!img) {
            var th = rows[i].querySelector('.mt-mix__thumb');
            if (th) th.innerHTML = '<img src="' + esc(v.img) + '" alt="" width="36" height="36" loading="lazy">';
          } else if (img.getAttribute('src') !== v.img) img.setAttribute('src', v.img);
        }
      }
      var fx = [];
      for (var j2 = 0; j2 < this.O.length; j2++) {
        if (this.act.indexOf(this.O[j2].i) > -1) continue;
        fx.push(this.O[j2].n + ': ' + this.mem[0][j2]);
      }
      this.fixedEl.textContent = fx.length ? fx.join(' · ') + ' on every item' : '';
      this.fixedEl.hidden = !fx.length;
    }

    // properties do carrinho: "2× Snowflake Wand, 1× Gift Wand" e "MT-REF-04-01 ×2, MT-REF-04-04 ×1"
    write() {
      var groups = [], idx = {};
      for (var i = 0; i < this.n; i++) {
        var p = this.mem[i], lab = p.map(clean).join(' / ');
        if (idx[lab] === undefined) { idx[lab] = groups.length; groups.push({ lab: lab, p: p, c: 0 }); }
        groups[idx[lab]].c++;
      }
      var items = [], skus = [], skuOk = true;
      for (var g = 0; g < groups.length; g++) {
        items.push(groups[g].c + '× ' + groups[g].lab);
        var one = this.oneUnit(groups[g].p);
        if (one && one.s) skus.push(clean(one.s) + ' ×' + groups[g].c); else skuOk = false;
      }
      this.pItems.setAttribute('name', 'properties[Items]');
      this.pItems.value = items.join(', ');
      if (skuOk && skus.length) {
        this.pSkus.setAttribute('name', 'properties[_SKUs]');
        this.pSkus.value = skus.join(', ');
      } else {
        this.pSkus.removeAttribute('name'); this.pSkus.value = '';
      }
    }

    // ---------- interação ----------
    onRow(e) {
      var sel = e.target && e.target.closest ? e.target.closest('select[data-k]') : null;
      if (!sel || this.hidden) return;
      e.stopPropagation();
      var row = sel.closest('.mt-mix__row'), i = +row.getAttribute('data-i');
      var j = this.jOf(+sel.getAttribute('data-k'));
      if (j < 0 || !this.mem[i]) return;
      var p = this.mem[i].slice();
      p[j] = sel.value;
      p = this.fix(this.tier, p, j);
      this.mem[i] = p;
      this.paint();
      this.write();
      if (i === 0) this.pushToMain(p); else this.showMedia(p);
    }

    // Item 1 = variante do carrinho: marca a pill/o select do tema e deixa o tema trocar variante, preço, URL e sticky.
    pushToMain(p) {
      var vs = document.getElementById('variant-selects-' + this.sid);
      if (!vs) return;
      var boxes = vs.querySelectorAll('.product-form__input'), last = null;
      for (var j = 0; j < this.O.length; j++) {
        var box = boxes[this.O[j].i], val = p[j];
        if (!box) continue;
        var type = box.querySelector('.product-form__input__type');
        type = type ? type.getAttribute('data-type') : '';
        if (type === 'dropdown') {
          var sel = box.querySelector('select');
          if (sel && sel.value !== val) { sel.value = val; last = sel; }
          continue;
        }
        var radios = box.querySelectorAll('input[type="radio"]');
        for (var r = 0; r < radios.length; r++) {
          if (radios[r].value === val) {
            if (!radios[r].checked) { radios[r].checked = true; last = radios[r]; }
            break;
          }
        }
      }
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Itens 2+: no desktop (galeria com miniaturas, sem rolar a página) mostra a foto escolhida
    showMedia(p) {
      if (!window.matchMedia || !window.matchMedia('(min-width: 750px)').matches) return;
      var v = this.find(this.tier, p);
      if (!v || !v.m) return;
      var id = this.sid + '-' + v.m;
      var gs = document.querySelectorAll('[id^="MediaGallery-' + this.sid + '"]');
      for (var g = 0; g < gs.length; g++) {
        var gal = gs[g];
        if (typeof gal.setActiveMedia !== 'function' || !gal.elements || !gal.elements.thumbnails) continue;
        if (gal.dataset.desktopLayout === 'stacked') continue;
        if (!gal.querySelector('[data-media-id="' + id + '"]')) continue;
        try { gal.setActiveMedia(id, false); } catch (err) { /* galeria sem a foto: não mexe */ }
      }
    }
  }

  customElements.define('mt-mix-picker', MtMix);
})();
